import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { Athlete, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useIndependentToLinked(): UseMutationResult<
  AxiosResponse,
  AxiosError<ErrorMessage>,
  { athleteId: string; primaryAccount: string }
> {
  const queryClient = useQueryClient();

  const independentToLinked = ({
    athleteId,
    primaryAccount,
  }: {
    athleteId: string;
    primaryAccount: string;
  }): Promise<AxiosResponse<Athlete>> => {
    return client.put(`athletes/${athleteId}/independent-to-linked/`, { primaryAccount });
  };

  return useMutation(independentToLinked, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['athletes'],
      });
      queryClient.invalidateQueries({
        queryKey: ['connectedAthletes'],
      });
      queryClient.invalidateQueries({
        queryKey: ['paymentMethods'],
      });
    },
  });
}
